export const enum ReviewSummarySource {
  GOOGLE_MAPS = 'google_maps',
  FUNNOW = 'funnow',
}

export const enum ReviewSummaryType {
  OVERVIEW = 'overview',
  PRODUCT_USP = 'product_usp',
  VIBE_SERVICE = 'vibe_service',
}
